/*eslint-disable */
export default {
  service: {
    game: {
      name: 'Dịch Vụ Game',
      description: 'Dịch Vụ Game'
    },
    stream: {
      name: 'Dịch Vụ Stream',
      description: 'Dịch Vụ Stream'
    },
    user: {
      name: 'Dịch Vụ Người Dùng',
      description: 'Dịch Vụ Người Dùng'
    },
    admin: {
      name: 'Dịch Vụ Quản Trị',
      description: 'Dịch Vụ Quản Trị'
    },
    wallet: {
      name: 'Dịch Vụ Ví',
      description: 'Dịch Vụ Ví'
    },
    setting: {
      name: 'Cài Đặt',
      description: 'Cài Đặt'
    },
    login: {
      logout: 'Đăng Xuát'
    }
  },
  stream: {
    scenario: {
      title: 'Scenario Management'
    },
    contact: {
      title: 'Contact Management',
    },
    report: {
      title: 'Report Management'
    },
    provider: {
      title: 'Provider Management'
    },
    campaign: {
      title: 'Campaign Management',
      button: {
        uploadFile: 'Upload File',
        inactive: 'Inactive',
        active: 'Active'
      },
      table: {
        stt: 'stt',
        link: 'Link Download',
        status: 'Status',
        version: 'Version',
        operation: 'Action'
      }
    },
  },
  alert: {
    roleButton: "Don't Right"
  }
}
